module.exports = __webpack_public_path__ + "static/media/online-frame.14bfe536.png";